'use strict';

/**
 * Updates the active dot to match the card currently most visible in the track.
 * @param {HTMLElement} track  The scroll track element.
 * @param {NodeList}    dots   The dot elements.
 */
function syncDots(track, dots) {
    var cards = track.querySelectorAll('.js-recipe-card');
    if (!cards.length || !dots.length) return;

    var trackLeft = track.getBoundingClientRect().left;
    var closestIndex = 0;
    var minDist = Infinity;

    Array.prototype.forEach.call(cards, function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < minDist) {
            minDist = dist;
            closestIndex = i;
        }
    });

    Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
    });
}

/**
 * Scrolls the track so the card at `index` is aligned to the start.
 * @param {HTMLElement} track The scroll track element.
 * @param {number}      index Zero-based card index.
 */
function scrollToCard(track, index) {
    var cards = track.querySelectorAll('.js-recipe-card');
    var card  = cards[index];
    if (!card) return;
    track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
}

/**
 * Initialises one recipe-cards block.
 * @param {HTMLElement} root The `.recipe-cards` wrapper element.
 */
function initBlock(root) {
    var track = root.querySelector('.js-recipe-track');
    var dotsContainer = root.querySelector('.js-recipe-dots');
    if (!track) return;

    var dots = dotsContainer ? dotsContainer.querySelectorAll('.recipe-cards__dot') : [];

    // Sync dots on scroll (debounced via requestAnimationFrame)
    var scrollRaf = null;
    track.addEventListener('scroll', function () {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
            syncDots(track, dots);
        });
    }, { passive: true });

    // Dot click → scroll to matching card
    Array.prototype.forEach.call(dots, function (dot, i) {
        dot.addEventListener('click', function () {
            scrollToCard(track, i);
        });
    });

    // Initial sync
    syncDots(track, dots);
}

/**
 * Bootstraps all recipe card blocks on the page.
 */
function init() {
    var blocks = document.querySelectorAll('.recipe-cards');
    Array.prototype.forEach.call(blocks, initBlock);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
